import styled, { css } from 'styled-components';
import rem from 'polished/lib/helpers/rem';
// template components
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Picture from '@nmx/template/dist/componentLibrary/components/Picture';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';

export const ColStyledLeft = styled(Col)`
  ${({ theme }) => {
    const xlargeUp = theme.xlargeUp();
    const largeUp = theme.largeUp();
    const mediumUp = theme.mediumUp();
    let paddingRight = 0;

    if (xlargeUp) {
      paddingRight = 65;
    } else if (largeUp) {
      paddingRight = 40;
    } else if (mediumUp) {
      paddingRight = 30;
    }

    return css`
      padding-right: ${rem(paddingRight)};
    `;
  }}
`;

export const ColStyledRight = styled(Col)`
  ${({ theme }) => {
    const xlargeUp = theme.xlargeUp();
    const largeUp = theme.largeUp();
    const mediumUp = theme.mediumUp();
    let paddingLeft = 0;
    if (xlargeUp) {
      paddingLeft = 65;
    } else if (largeUp) {
      paddingLeft = 40;
    } else if (mediumUp) {
      paddingLeft = 30;
    }
    return css`
      padding-left: ${rem(paddingLeft)};
    `;
  }}
`;

export const PictureStyled = styled(Picture)`
  ${({ theme }) => {
    const mediumUp = theme.mediumUp();

    return css`
      padding-bottom: ${mediumUp ? 0 : rem(32)};
    `;
  }}
`;

export const RowStyled = styled(Row)`
  ${({ theme, reverse, hasBorder }) => {
    const mediumUp = theme.mediumUp();
    const thisSpacing = mediumUp ? rem(60) : rem(48);

    return css`
      ${hasBorder && `
        margin-bottom: ${thisSpacing};
        padding-bottom: ${thisSpacing};
        border-bottom: ${rem(1)} solid ${theme.colors.neutral.grayLight1};
      `};
      ${reverse && `flex-direction: ${mediumUp ? 'row' : 'column-reverse'};`};
    `;
  }}
`;